import { BreadcrumbItem, type BreadcrumbItemProps } from '@chakra-ui/react';

export type UiBreadcrumbItemProps = BreadcrumbItemProps;

export const UiBreadcrumbItem = BreadcrumbItem;
